import axios from 'axios'

var qs = require('qs');
var root=window.API_ROOT


//获取列表数据
export const getListData = (params) => {
  return axios.post(root+'/set/jxcgoodscategory/list', qs.stringify(params))
}
export const listLens = (params) => {
  return axios.post(root+'/set/jxcgoodscategory/listLens', qs.stringify(params))
}
export const listLensWithSeries = (params) => {
  return axios.post(root+'/set/jxcgoodscategory/listLensWithSeries', qs.stringify(params))
}
//删除行
export const deleteData = (params) => {
  return axios.post(root+'/set/jxcgoodscategory/remove',  qs.stringify(params))
}

//获取某一行的明细数据
export const getDetail = (params) => {
  return axios.post(root+'/set/jxcgoodscategory/edit', qs.stringify(params))
}
export const getCategoryDetail = (params) => {
  return axios.post(root+'/set/jxcgoodscategory/edit', qs.stringify(params))
}

//保存某一行的数据
export const saveData = (params) => {
  if (params.categorycode) {//修改
    return axios.post(root+'/set/jxcgoodscategory/update', qs.stringify(params))
  } else {//添加
    return axios.post(root+'/set/jxcgoodscategory/save',qs.stringify(params))
  }
}

export const saveupdate = (params) => {
  return axios.post(root + '/set/jxcgoodscategory/saveupdate', qs.stringify(params))
}

//获取产品类型树
export const getjdTree =(params) => {
  return axios.post(root+'/set/jxcgoodscategory/tree',qs.stringify(params))
}

//获取查询条件
export const getquery =(params) => {
  return axios.post(root+'/set/jxcgoodscategory/findquery',qs.stringify(params))
}

//获取form属性
export const getform =(params) => {
  return axios.post(root+'/set/jxcgoodscategory/findform',qs.stringify(params))
}

//获取form属性
export const getGoodsDetail =(params) => {
  return axios.post(root+'/set/jxcgoodscategory/getGoodsDetail',qs.stringify(params))
}

export const listSupplygoods=(params) => {
  return axios.post(root+'/set/jxcgoodscategory/listSupplygoods',qs.stringify(params))
}

export const getCategory = (params) => {
  return axios.post(root+'/set/jxcgoodscategory/getcategory', qs.stringify(params))
}



// WEBPACK FOOTER //
// ./src/api/set/jxcgoodscategory.js